WiseMetering.Views.NewInfraspeakConfiguration = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'integration_configuration',
    template: 'templates/integration_configurations/infraspeak/new',
    title: () => i18next.t('modal.title.integration_configurations.new'),
    buttons: ['validate', 'save', 'cancel'],

    events: {
        'click #validate': 'validate'
    },

    ui: {
        site_reference: '#integration_configuration_site_reference',
        sites: '#integration_configuration_site_id',
        name: '#integration_configuration_name',
        token: '#integration_configuration_token',
        url: '#integration_configuration_url'
    },

    fetchExternalSites: function(token, licenseId) {
        this.modal.block();

        const payload = {
            token: token,
            license_id: licenseId
        };

        $.ajax({
            url: '/integration_configurations/external_sites',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(payload),
            success: function(data) {
                data.sort((a, b) => a.site_reference_name.localeCompare(b.site_reference_name));

                $('#save').prop('disabled', false);
                this.ui.token.prop('disabled', true);
                this.ui.site_reference.prop('disabled', false);
                this.ui.site_reference.html(WiseMetering.utils.optionsFromArray(data, null, 'site_reference', 'site_reference_name'));
                this.modal.unblock();
            }.bind(this),
            error: function() {
                WiseMetering.layout.showTipper('error', i18next.t('integrations.validation_failed'));
                $('#save').prop('disabled', true);
                this.ui.token.prop('disabled', false);
                this.modal.unblock();
            }.bind(this)
        });
    },

    getFormData: function() {
        const data = this.formSerializer();
        data.site_reference_name = this.ui.site_reference.find(':selected').text();
        return data;
    },

    onShow: function() {
        const
            usedSiteIds = this.model.license().configurations().pluck('site_id'),
            sites = WiseMetering.zones.activeSites().models.filter(site => !usedSiteIds.includes(site.id));

        $('#save').prop('disabled', true);

        this.ui.sites.html(WiseMetering.utils.optionsFromModels(sites, 'name', null, true));
    },

    validate: function() {
        const
            token = this.ui.token.val(),
            licenseId = this.model.get('license_id');

        if (token.length < 1 || token === i18next.t('integrations.insert_token')) {
            $('#integration_token').val(i18next.t('integrations.insert_token'));
            return;
        }

        this.fetchExternalSites(token, licenseId);
    }
});
